import styled from 'styled-components';

const MapContainer = styled.div<{ height: string }>`
  display: flex;
  height: ${props => props.height};
  width: 100%;
`;
export default MapContainer;
